import { render, staticRenderFns } from "./CustomerInventory.vue?vue&type=template&id=49457b6b&scoped=true&"
import script from "./CustomerInventory.vue?vue&type=script&lang=js&"
export * from "./CustomerInventory.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInventory.vue?vue&type=style&index=0&id=49457b6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49457b6b",
  null
  
)

export default component.exports